import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { customStyles } from "../../style/selectStyles";
import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { DefaultButton, MyModalBody, MyModalInput } from "../../style/default";

function ModalLandbotCreate({ open, populateTable, clients }) {
  const { handleOpenModal } = useContext(ModalContext);
  const [channelToken, setChannelToken] = useState("");
  const [accountId, setAccountId] = useState("");

  const handleLandbotCreate = async () => {
    if (!accountId.value) {
      toast.error("Cliente não informado!", TOASTIFY_OPTIONS);
      return;
    }
    if (!channelToken) {
      toast.error("Insira o token!", TOASTIFY_OPTIONS);
      return;
    }

    try {
      const reqData = await authApi.post("/landbotchannel/create", {
        accountId: accountId.value,
        channelToken: channelToken,
      });
      if (reqData.status === 200) {
        populateTable();
        handleOpenModal();
        toast.success("Canal landbot criado com sucesso.", TOASTIFY_OPTIONS);
      }
    } catch (error) {
      toast.error("Houve um erro interno!", TOASTIFY_OPTIONS);
      handleOpenModal();
    }
  };

  return (
    <Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
      <Modal.Header closeLabel="" closeButton>
        <Modal.Title>Cadastrar novo canal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MyModalBody>
          <label>Cliente:</label>
          <Select
            styles={customStyles}
            placeholder={"Filtrar por cliente"}
            options={clients}
            onChange={(e) => {
              setAccountId(e);
            }}
            value={accountId}
            noOptionsMessage={"Nenhum dado encontrado!"}
          />

          <label style={{ marginTop: "1rem" }}>Token</label>
          <MyModalInput
            type="name"
            placeholder={"ex: ti"}
            onChange={(e) => setChannelToken(e.target.value)}
            value={channelToken}
          />
        </MyModalBody>
      </Modal.Body>
      <Modal.Footer>
        <DefaultButton onClick={handleLandbotCreate}>Cadastrar</DefaultButton>
      </Modal.Footer>
    </Modal>
  );
}

export { ModalLandbotCreate };
